export default {
	render (createElement) {
		return createElement(
			this.tag, // tag name
			this.$slots.default // array of children
		)
	},
	props: {
		tag: {
			default: 'div',
			type: String
		}
	}
}
